import React from 'react'
import { Slider as MuiSlider, SliderProps } from '@mui/material'
import './Slider.sass'

interface CustomSliderProps extends Omit<SliderProps, 'sx'> {
    sx?: any
}

function CustomSlider({ 
    className = '', 
    sx = {}, 
    ...props 
}: CustomSliderProps) {
    return (
        <MuiSlider
            {...props}
            className={`custom-slider ${className}`}
            sx={sx}
        />
    )
}

export default CustomSlider
